import { SCOPE } from './types';

const selector = state => state[SCOPE];

export default selector;
